<template>
  <div class="container-comment" v-if="userId!=null||userId==null&&searchResultList.length>0">
    <div class="header-tab" v-on:click="Toggle('comment')">
        <h3>{{ $t("new.title158") }}<!--  -->
            <span><p>&#128317;</p></span>
        </h3>
    </div>
    <div class="add-comment">
        <button v-if="userId!=null" v-on:click="OpenModal()">{{ $t("new.title159") }}</button>
        <!-- The Modal -->
        <div id="myModal" class="modal">
            <!-- Modal content -->
            <div class="modal-content">
                <span v-on:click="CloseModal()" class="close">&times;</span>
                <!-- <p class="title-course">{{data.courseName}}</p> -->
                <p style="padding:10px;font-size:16px">{{ $t("new.title160") }}</p>
                <form class="comment-form" @submit.prevent="addComment"  method="post">
                    <div class="rate">
                        <input type="radio" id="star5" name="rate" v-model="rate" value="5" />
                        <label for="star5" title="text">.</label>
                        <input type="radio" id="star4" name="rate" v-model="rate" value="4" />
                        <label for="star4" title="text">.</label>
                        <input type="radio" id="star3" name="rate" v-model="rate" value="3" />
                        <label for="star3" title="text">.</label>
                        <input type="radio" id="star2" name="rate" v-model="rate" value="2" />
                        <label for="star2" title="text">.</label>
                        <input type="radio" id="star1" name="rate" v-model="rate" value="1" />
                        <label for="star1" title="text">.</label>
                    </div>
                    <div class="comment-name">
                        <p>{{ $t("new.title230") }}</p>
                    </div>
                    <div class="comment-name">
                        <input type="text" name="commentName" v-model="commentName" />
                    </div>
                    <div class="comment-fill">
                        <textarea name="comment" v-model="commentCourse" cols="30" rows="10" :placeholder='$t("new.title232")'></textarea>
                    </div>
                    <button class="submit">{{ $t("new.title161") }}</button>
                </form>
            </div>
        </div>
    </div>
    <template v-if="comment">
        <div class="comment" v-for="(comments, index) in listComment" :key="index">
            <div class="comment-item">
                <img class="avatar-student" v-if="comments.headImagePath == undefined || comments.headImagePath == null || comments.headImagePath == ''" src="../../../../static/images/profile.jpg" alt="/" />
                <img class="avatar-student" v-else :src="comments.headImagePath" :alt="comments.headImagePath" @error="setAltStudent" />
                <div class="info-comment">
                    <p v-if="comments.name" class="item-name">{{comments.name}}</p>
                    <p v-else class="item-name">{{ $t("new.title231") }}</p>
                    <a v-if="comments.evaluate == 1" class="item-rating">&#9733;&#9734;&#9734;&#9734;&#9734;</a>
                    <a v-else-if="comments.evaluate == 2" class="item-rating">&#9733;&#9733;&#9734;&#9734;&#9734;</a>
                    <a v-else-if="comments.evaluate == 3" class="item-rating">&#9733;&#9733;&#9733;&#9734;&#9734;</a>
                    <a v-else-if="comments.evaluate == 4" class="item-rating">&#9733;&#9733;&#9733;&#9733;&#9734;</a>
                    <a v-else-if="comments.evaluate == 5" class="item-rating">&#9733;&#9733;&#9733;&#9733;&#9733;</a>
                    <p class="item-time">{{comments.timeComment}}</p>
                </div>
            </div>
            <div class="comment-content">
                <p>{{comments.comment}}</p>
            </div>
        </div>
        <!-- Phân trang -->
        <div style="text-align: center; margin-top: 10px; margin-bottom: 10px;" v-if="resultFlag">
            <el-pagination background @current-change="handleCurrentChange" :current-page="pageNum" :page-size="pageSize" layout="prev, pager, next" :total="searchResultList.length"></el-pagination>
        </div>
        <div v-if="searchResultList.length<=0">
            <p class="none-comment">{{ $t("new.title197") }}</p>
        </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Comment',
  props: {
    msg: String,
    data: {
      type: Object,
      default: {}
    }
  },
  data(){
      return{
            comment : true,
            outlineInfo: eval("(" + this.$route.query.outlineInfo + ")"),
            rate: 5,
            commentCourse: null,
            commentName: this.$i18n.t("new.title233"),
            userId: null,
            headImagePath:null,
            checkClickMoreComment: false,
            resultFlag: true,
            pageNum: 1,
            page: 1,
            pageSize: 5,
            searchResultList: []
      }
  },
  mounted(){
     
  },
 created() {
      this.$autoLogin().then(
          () => {
            this.userId = this.$attrs.userId || window.sessionStorage.getItem("id");
            this.headImagePath = window.sessionStorage.getItem("headImagePath")
          },
          () => {
              this.userId = null;
          }
      );
      this.getListUserEvaluate();
    },
    methods: {
        //Lấy danh sách comment
        getListUserEvaluate() {
            this.$api.post("/evaluate/getListUserEvaluate", {
                courseId : this.outlineInfo.courseId,
                limit : null
            })
            .then((response) => {
                this.searchResultList = response.data.userInfo;
                this.searchResultList = this.searchResultList.reverse();
                if (this.searchResultList.length==0) {
                    this.resultFlag = false;
                }
            })
            .catch((err) => {
                // console.log(err.response);
            });
        },
         setAltStudent(event) { 
            event.target.src = "../../../static/images/profile.jpg" ;
         },
        //đóng mở tab comment
        Toggle(value){
            if(value == "comment"){
                this.comment = !this.comment;
            }
        },
        //mở cửa sổ comment
        OpenModal(){
            document.getElementById("myModal").style.display = "block"
            document.getElementById("shopping-cart").style.display = "none"
        },
        //đóng cửa sổ comment
        CloseModal(){
            document.getElementById("myModal").style.display = "none"
            document.getElementById("shopping-cart").style.display = "block"
        },
        //Thêm comment
        addComment(){
            let checkSpaceComment = /^\s+$/;
            if (this.commentCourse==null||this.commentCourse==""||checkSpaceComment.test(this.commentCourse)) {
                this.$message.warning(window.vm.$i18n.t("new.title198"));
                return;
            }
            this.$api.post("/evaluate/insertUserEvaluate", {
                courseId : this.outlineInfo.courseId,
                userId : window.sessionStorage.getItem("id"),
                evaluate: this.rate,
                comment: this.commentCourse,
                name: this.commentName
            })
            .then((response) => {
                this.getListUserEvaluate();
                this.CloseModal();
                })
            .catch((err) => {
                // console.log(err);
            });
        },
        handleCurrentChange(val) {
            this.page = val;
        },
    },
    computed: {
        listComment() {
            this.pageSize = 5;
            return this.searchResultList.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .header-tab h3{
    background-color:#DDDDDD;
    padding: 10px;
    font-weight: 400;
    margin-bottom: 10px;
    font-size: 16px;
}
.header-tab span{
    float: right;
    cursor: pointer;
}
.header-tab span p{
    margin: 0px;
}
.container-comment .comment{
    display: flex;
    border: 1px solid #0071c5;
    margin: 10px;
    border-radius: 20px;
    font-size: 16px;
}
.container-comment > .comment .comment-item {
    padding: 5px;
    width: 30%;
    display:flex;
    align-items: center;
}
.container-comment > .comment .comment-item .avatar-student{
    padding: 5px;
    width: 70px;
    height:70px;
    border-radius: 50%;
    margin-right: 20px;
}
.container-comment > .comment .comment-content {
  cursor: pointer;
  padding: 10px;
  width: 80%;
    display: -webkit-box;
    max-height: 5.5rem;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    -webkit-line-clamp: 3;
    line-height: 1.6rem;
    transition-delay: 2s;
    word-break: break-word;
}
.container-comment > .comment .comment-content:hover{
  display: block;
  max-height: none;
}
.container-comment .none-comment{
    font-size: 16px;
    padding: 20px;
    color: #666666;
}
.info-comment{
    padding: 5px;
}
.item-rating{
    font-size: 150%;
    color: #cb0d0d;
}
.item-time{
    color:  #999;
}
.container-comment .add-comment  button{
    padding: 10px 20px;
    background: #000099;
    border: none;
    color: #ffff;
    font-size: 20px;
    border-radius: 5px;
    display: block;
    margin: 15px auto;
    cursor: pointer;
    
}
/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 50%;
  border-radius: 10px;
}

/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

#myModal .modal-content .title-course{
    font-size: 22px;
    font-weight:600;
    color: #007aff;
    word-break: break-word;
}
#myModal .modal-content .title-comment{
    font-family: Arial, Helvetica, sans-serif;
    color: #666666;
}
.comment-form .comment-fill textarea{
        width: 100%;
        border: 1px solid #007aff;
        resize: none;
}
.comment-name p{
    width: 100%;
    float: left;
    font-size: 16px;
}
.comment-name input {
    width: 100%;
    height: 25px;
    border: 1px solid #007aff;
    margin-top: 5px;
    margin-bottom: 5px;
}


@media only screen and (max-width: 600px) {
    .container-comment .comment{
        display: flex;
        flex-direction: column;
    }
    .container-comment > .comment .comment-item {
        display: flex;
        width: 100%;
    }
    .container-comment > .comment .comment-content {
        width: 100%;
    }
    .modal-content {
        background-color: #fefefe;
        margin: auto;
        padding: 20px;
        border: 1px solid #888;
        width: 90%;
    }
}

.rate {
    float: left;
    padding: 15px;
}
.rate:not(:checked) > input {
    position:absolute;
    top:-9999px;
}
.rate:not(:checked) > label {
    float:right;
    width:1em;
    overflow:hidden !important;
    white-space:nowrap;
    cursor:pointer;
    font-size:30px;
    color:#ccc;
}
.rate:not(:checked) > label:before {
    content: '★ ';
    border: 0px !important;
}
.rate:not(:checked) > label:after{
    content: none !important;
}
.rate > input:checked ~ label {
    color: #ffc700;    
}
.rate:not(:checked) > label:hover,
.rate:not(:checked) > label:hover ~ label {
    color: #deb217;  
}
.rate > input:checked + label:hover,
.rate > input:checked + label:hover ~ label,
.rate > input:checked ~ label:hover,
.rate > input:checked ~ label:hover ~ label,
.rate > label:hover ~ input:checked ~ label {
    color: #c59b08;
}

/* Modified from: https://github.com/mukulkant/Star-rating-using-pure-css */
.more_comment {
    text-align: center;
    margin-bottom: 10px;
}
.more_comment button {
    width: 98%;
    padding: 10px;
    background-color: #fff;
    border-color: gray;
    color: #0071c5;
    border-radius: 5px;
    font-weight: bold;
    font-size: 17px;
    border: 1px solid;
    background: aliceblue;
}
.header-tab {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/defineSelfCourse/detailsSelfCourse/comment.vue